// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logout__fullpage___Dfnn0 {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: flex-start;

    width: 100%;
    height: 100%;

    background: #fff;
}

.Logout__leftBlock___pMWbH {
    width: calc(100% - 50rem);
    height: 100%;
    margin-left: 0;
    background: #48d;
}

.Logout__rightBlock___Nlq6r {
    position: relative;

    overflow: auto;
    display: flex;
    flex-flow: column nowrap;
    place-content: flex-start;

    box-sizing: border-box;
    width: 50rem;
    height: 100%;
    margin: 0;
    padding: 9rem 15rem 0 5rem;

    background: #fff;
}

.Logout__logoBlock___X0Uur {
    width: 35rem;
    height: 10rem;
    word-wrap: break-word;
}

.Logout__companyLogo___UPMNR {
    width: auto;
    height: auto;
}

.Logout__textBlock___rbHDh {
    width: 350rem;
    height: 10rem;
    margin-top: 10rem;
}

.Logout__message___i5728 {
    width: 35rem;
    margin: 0;
    padding: 0;

    font-family: 'Segoe UI', Segoe, SegoeUI-Regular-final, Tahoma, Helvetica, Arial, sans-serif;
    font-weight: normal;
    color: #000;
}

.Logout__footerLink___9tQ4R {
    width: 35rem;
    height: 10rem;
    margin-top: 4rem;
}

.Logout__link___tVTdg {
    font-family: 'Segoe UI', Segoe, SegoeUI-Regular-final, Tahoma, Helvetica, Arial, sans-serif;
    font-weight: normal;
    color: #2672ec;
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Utils/src/auth/Logout/Logout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;;IAE3B,WAAW;IACX,YAAY;;IAEZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,yBAAyB;;IAEzB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,0BAA0B;;IAE1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;;IAEV,2FAA2F;IAC3F,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,2FAA2F;IAC3F,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB","sourcesContent":[".fullpage {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    width: 100%;\n    height: 100%;\n\n    background: #fff;\n}\n\n.leftBlock {\n    width: calc(100% - 50rem);\n    height: 100%;\n    margin-left: 0;\n    background: #48d;\n}\n\n.rightBlock {\n    position: relative;\n\n    overflow: auto;\n    display: flex;\n    flex-flow: column nowrap;\n    place-content: flex-start;\n\n    box-sizing: border-box;\n    width: 50rem;\n    height: 100%;\n    margin: 0;\n    padding: 9rem 15rem 0 5rem;\n\n    background: #fff;\n}\n\n.logoBlock {\n    width: 35rem;\n    height: 10rem;\n    word-wrap: break-word;\n}\n\n.companyLogo {\n    width: auto;\n    height: auto;\n}\n\n.textBlock {\n    width: 350rem;\n    height: 10rem;\n    margin-top: 10rem;\n}\n\n.message {\n    width: 35rem;\n    margin: 0;\n    padding: 0;\n\n    font-family: 'Segoe UI', Segoe, SegoeUI-Regular-final, Tahoma, Helvetica, Arial, sans-serif;\n    font-weight: normal;\n    color: #000;\n}\n\n.footerLink {\n    width: 35rem;\n    height: 10rem;\n    margin-top: 4rem;\n}\n\n.link {\n    font-family: 'Segoe UI', Segoe, SegoeUI-Regular-final, Tahoma, Helvetica, Arial, sans-serif;\n    font-weight: normal;\n    color: #2672ec;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullpage": `Logout__fullpage___Dfnn0`,
	"leftBlock": `Logout__leftBlock___pMWbH`,
	"rightBlock": `Logout__rightBlock___Nlq6r`,
	"logoBlock": `Logout__logoBlock___X0Uur`,
	"companyLogo": `Logout__companyLogo___UPMNR`,
	"textBlock": `Logout__textBlock___rbHDh`,
	"message": `Logout__message___i5728`,
	"footerLink": `Logout__footerLink___9tQ4R`,
	"link": `Logout__link___tVTdg`
};
export default ___CSS_LOADER_EXPORT___;
